import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StockAdjustmentBatchService = {
  getProductBatches(code, lineNo) {
    const requestScreenData = {
      url: "api/StockAdjustmentProductBatch",
      filter: `StockAdjustmentCode eq ${code} and StockAdjustmentLineNo eq ${lineNo}`,
    };

    return ApiService.oDataGet(requestScreenData);
  },


  dataSourceConfig(paramUrl, params) {
    var url = "api/" + paramUrl;
    return ApiService.createDataSource(url, params);
  },


  async getCustomDataSocurce(paramUrl, params) {
    const requestScreenData = {
      url: "api/" + paramUrl,
      filter: params.filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { StockAdjustmentBatchService };
